<template>
  <div class="modal fade"
       id="modal-create-product"
       tabindex="-1"
       role="dialog"
       data-bs-backdrop="static"
       data-bs-keyboard="false">
    <div class="modal-dialog modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h5 class="modal-title">{{ product ? 'Modifier le produit' : 'Ajouter un produit' }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
        </div>
        <div class="modal-body">
          <ValidationObserver ref="observer" v-slot="{ invalid }">
            <form @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <ValidationProvider name="Nom" rules="required" v-slot="{ errors }">
                    <label class="form-label">Nom du produit <span class="text-danger">*</span></label>
                    <input v-model="payload.name" type="text" class="form-control" placeholder="Ex: Clavier" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-6">
                  <ValidationProvider name="Prix de référence" rules="required|min_value:1" v-slot="{ errors }">
                    <label class="form-label">Prix de référence <span class="text-danger">*</span></label>
                    <input v-model="payload.referencePrice" type="number" class="form-control" placeholder="0.00" step="0.01" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-6">
                  <ValidationProvider name="Commission" rules="required|min_value:0|max_value:100" v-slot="{ errors }">
                    <label class="form-label">Taux de commission (%) <span class="text-danger">*</span></label>
                    <input v-model="payload.commissionRate" type="number" class="form-control" placeholder="0.00" step="0.01" />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-6">
                  <ValidationProvider name="Alerte quantité" rules="required|min_value:0" v-slot="{ errors, touched }">
                    <label class="form-label">Alerte quantité <span class="text-danger">*</span></label>
                    <input type="number" v-model="payload.quantityAlert" class="form-control" placeholder="Ex: 10" min="0" />
                    <small class="text-danger" v-if="touched">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <ValidationProvider name="Famille" rules="required" v-slot="{ errors }">
                      <label class="form-label">Famille <span class="text-danger">*</span></label>
                      <multi-select v-model="payload.familyCode"
                                    deselect-label="Rechercher"
                                    select-label="" :options="allFamilies"
                                    @select="updateFamilyDetails"
                                    placeholder="Sélectionnez une famille"
                                    :searchable="true">
                        <template slot="option" slot-scope="{ option }">
                          <span>{{ option.code }} - {{ option.label || option.description }}</span>
                        </template>
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span>{{ option.code }} - {{ option.label || option.description }}</span>
                        </template>
                        <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                        <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                      </multi-select>

                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <ValidationProvider name="Catégorie" rules="required" v-slot="{ errors }">
                      <label class="form-label">Catégorie <span class="text-danger">*</span></label>

                      <multi-select v-model="payload.categoryCode"
                                    deselect-label="Rechercher" select-label=""
                                    @select="updateCategoryDetails"
                                    :options="allCategories"
                                    placeholder="Sélectionnez une catégorie"
                                    :searchable="true">
                        <template slot="option" slot-scope="{ option }">
                          <span>{{ option.code }} - {{ option.label || option.description }}</span>
                        </template>
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span>{{ option.code }} - {{ option.label || option.description }}</span>
                        </template>
                        <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                        <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                      </multi-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <ValidationProvider name="Unité de base" rules="required" v-slot="{ errors }">
                      <label class="form-label">Unité de base <span class="text-danger">*</span></label>

                      <multi-select v-model="payload.baseUnitCode"
                                    deselect-label="Rechercher" select-label=""
                                    :options="allUnits"
                                    @select="updateUnitDetails"
                                    placeholder="Sélectionnez l’unité de base"
                                    :searchable="true">
                        <template slot="option" slot-scope="{ option }">
                          <span>{{ option.code }} - {{ option.label || option.description }}</span>
                        </template>
                        <template slot="singleLabel" slot-scope="{ option }">
                          <span>{{ option.code }} - {{ option.label || option.description }}</span>
                        </template>
                        <span slot="noOptions">
                                                        <strong>Liste Vide</strong>
                                                    </span>
                        <span slot="noResult">
                                                        <strong>Aucun Résultat</strong>
                                                    </span>
                      </multi-select>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="form-group col-md-6">
                  <ValidationProvider name="Gestion du stock" rules="required" v-slot="{ errors }">
                    <label class="form-label">Type de gestion du stock <span class="text-danger">*</span></label>
                    <GenericSelect
                        :options="managementTypeOptions"
                        v-model="payload.managementType"
                        label-key="label"
                        track-key="value"
                        placeholder="Sélectionner un type"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </ValidationProvider>
                </div>

                <div class="form-group col-md-6">
                  <label class="form-label">Description</label>
                  <textarea v-model="payload.description" rows="3" class="form-control" placeholder="Description du produit"></textarea>
                </div>





              </div>

              <div class="form-group">
                <ValidationProvider name="Images" rules="hasImages" v-slot="{ errors }">
                  <div class="form-group">
                    <label class="form-label">Images du produit <span class="text-danger">*</span></label>
                    <FilePondUploader
                        ref="uploader"
                        :initial-files="payload.images"
                        @uploaded="handleUploadedUrls"
                        @removefile="onImageRemoved"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </div>
                </ValidationProvider>
              </div>

              <!-- Unités de vente -->
              <div class="card mt-3">
                <div class="card-body">
                  <button class="btn btn-sm btn-success" type="button"
                          :disabled="!baseUnitCodeValue"
                          @click.prevent="openCreate">
                    <i class="fe fe-plus me-1"></i> Ajouter
                  </button>
                  <div class="table-responsive mt-3">
                    <table class="table table-hover table-bordered text-nowrap mb-0">
                      <thead class="border-top success02">
                      <tr class="text-center">
                        <th class="fw-bold">Actions</th>
                        <th class="fw-bold">#</th>
                        <th class="fw-bold">Unité</th>
                        <th class="fw-bold">Contenu (× unité de base)</th>
                        <th class="fw-bold">Prix de vente</th>
                        <th class="fw-bold">Par défaut</th>
                      </tr>
                      </thead>
                      <tbody v-if="payload.sellingUnits.length > 0">
                      <tr v-for="(item, index) in payload.sellingUnits" :key="index">
                        <td class="text-center">
                          <button class="btn btn-sm btn-outline-primary me-1" @click.prevent="openEdit(index)">
                            <i class="fe fe-edit"></i>
                          </button>
                          <button class="btn btn-sm btn-outline-danger" @click.prevent="remove(index)">
                            <i class="fe fe-trash-2"></i>
                          </button>
                        </td>
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ displayUnit(item.unitCode) }}</td>
                        <td>{{ item.contentQty }}</td>
                        <td>{{ item.salePrice }}</td>
                        <td class="text-center">
                          <input type="radio" :checked="item.defaultUnit === true" @change="setDefault(index)" />
                        </td>
                      </tr>
                      </tbody>
                      <tbody v-else>
                      <tr class="primary02">
                        <td colspan="6" class="text-center">Aucune unité ajoutée.</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Modal ajout/édition  -->
              <SellingUnitsModal
                  v-if="showModal"
                  :all-units="allUnits"
                  :mode="editIndex === null ? 'create' : 'edit'"
                  :initial="editIndex !== null ? payload.sellingUnits[editIndex] : null"
                  :base-unit="(payload.baseUnitCode && payload.baseUnitCode.code) || payload.baseUnitCode"
                  :used-unit-codes="payload.sellingUnits.map(u => u.unitCode)"
              @close="closeModal"
              @save="ajouterUnit"
              @update="majUnit"
              />


              <!-- Champs personnalisés -->
              <div class="card mt-4">
                <div class="card-header d-flex justify-content-between align-items-center">
                  <h5 class="card-title mb-0">
                    <i class="fe fe-sliders me-2"></i> Champs personnalisés
                  </h5>
                  <button
                      class="btn btn-sm"
                      type="button"
                      @click="toggleCustomFields"
                  >
                    <i :class="showCustomFields ? 'fe fe-chevron-up' : 'fe fe-chevron-down'"></i>
                  </button>
                </div>
                <div v-if="showCustomFields" class="card-body">

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="chkGarantie" v-model="customFields.garantie">
                    <label class="form-check-label" for="chkGarantie">Garantie</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="chkFabricant" v-model="customFields.fabricant">
                    <label class="form-check-label" for="chkFabricant">Fabricant</label>
                  </div>

                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="chkExpiration" v-model="customFields.expiryDate">
                    <label class="form-check-label" for="chkExpiration">Expiration</label>
                  </div>

                  <div class="form-row mt-4">
                    <div class="form-group col-md-4" v-if="customFields.garantie">
                      <ValidationProvider name="Garantie" rules="required" v-slot="{ errors, touched }">
                        <label class="form-label">Garantie <span class="text-danger">*</span></label>
                        <select v-model="payload.garantie" class="form-control">
                          <option disabled value="">Choisir</option>
                          <option value="6_mois">6 mois</option>
                          <option value="1_an">1 an</option>
                          <option value="2_ans">2 ans</option>
                        </select>
                        <small class="text-danger" v-if="touched">{{ errors[0] }}</small>
                      </ValidationProvider>
                    </div>

                    <div class="form-group col-md-4" v-if="customFields.fabricant">
                      <ValidationProvider name="Fabricant" rules="required" v-slot="{ errors, touched }">
                        <label class="form-label">Fabricant <span class="text-danger">*</span></label>
                        <input type="text" v-model="payload.fabricant" class="form-control" />
                        <small class="text-danger" v-if="touched">{{ errors[0] }}</small>
                      </ValidationProvider>
                    </div>

                    <div class="form-group col-md-4" v-if="customFields.expiryDate">
                      <ValidationProvider name="Date d'expiration" rules="required" v-slot="{ errors, touched }">
                        <label class="form-label">Date d’expiration <span class="text-danger">*</span></label>
                        <input type="date" v-model="payload.expiryDate" class="form-control" />
                        <small class="text-danger" v-if="touched">{{ errors[0] }}</small>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>



              <div class="text-end mt-4">
                <button type="button" class="btn btn-gray me-2" data-bs-dismiss="modal" @click="resetForm" >Annuler</button>
                <button type="submit" class="btn btn-success" :disabled="invalid">
                  <i class="fe fe-check"></i> {{ product ? 'Modifier' : 'Créer' }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { confirmAction, showValidationErrors } from "../../helpers/helpers";
  import GenericSelect from "../GenericSelect.vue";
  import DropifyUploader from "../DropifyUploader.vue";
  import MultiImageUploader from "../MultiImageUploader.vue";
  import FilePondUploader from "../FilePondUploader.vue";
  import SellingUnitsModal from "./SellingUnitsModal.vue";

  export default {
    name: "ModalCreateProduct",
    components: {
      SellingUnitsModal, FilePondUploader, MultiImageUploader, DropifyUploader, GenericSelect},
    props: {
      product: {
        type: Object,
        default: null,
      },
      allFamilies:{
        type: Array,
        default: () => [],
      },
      allCategories:{
        type: Array,
        default: () => [],
      },
      allUnits:{
        type: Array,
        default: () => [],
      }
    },
    data() {
      return {
        allFamilies: [],
        allCategories: [],
        allUnits: [],
        managementTypeOptions: [
          { value: 'FIFO', label: 'Premier entré, premier sorti (FIFO)' },
          { value: 'LIFO', label: 'Dernier entré, premier sorti (LIFO)' },
          { value: 'CUMP', label: 'Coût unitaire moyen pondéré (CUMP)' },
        ],
        payload: {
          name: '',
          description: '',
          referencePrice: 0,
          initialStock: 0,           // ✅ NEW
          images: [
          ],
          sellingUnits: [],
          managementType: '',
          commissionRate: 0,
          familyCode: '',
          categoryCode: '',
          subcategoryCode: '',
          baseUnitCode: '',
          quantityAlert: 0,
          garantie: '',
          fabricant: '',
          expiryDate: null,

          familyDescription: '',
          categoryDescription: '',
          baseUnitLabel: ''
        },
        showCustomFields: true,
        customFields: {
          garantie: false,
          fabricant: false,
          expiryDate: false
        },
        showModal: false,
        editIndex: null,
        modalKey: 0,
      };
    },
    computed: {
      baseUnitCodeValue() {
        return this.payload.baseUnitCode?.code || this.payload.baseUnitCode || '';
      }
    },
    watch: {
      product: {
        immediate: true,
        handler(newVal) {
          this.payload = newVal
              ? { ...newVal }
              : {
                name: '',
                description: '',
                referencePrice: 0,
                images: [],
                managementType: '',
                commissionRate: 0,
                categoryCode: '',
                categoryDescription: '',
                familyCode: '',
                familyDescription: '',
                baseUnitCode: '',
                unitDescription: '',
                sellingUnits: []
              };

          this.customFields.garantie = !!newVal?.garantie;
          this.customFields.fabricant = !!newVal?.fabricant;
          this.customFields.expiryDate = !!newVal?.expiryDate;

          // ✅ Ajoute ce bloc pour retrigger la validation après chargement
          this.$nextTick(() => {
            if (this.$refs.observer && this.product) {
              this.$refs.observer.validate();
            }
          });
        },
      },
      'payload.baseUnitCode': {
        deep: true,
        handler() { this.ensureBaseUnitRow(); }
      },
      'payload.referencePrice'(v) {
        // Optionnel : si tu veux refléter le prix de référence sur la ligne "base"
        const base = this.baseUnitCodeValue;
        if (!base || !Array.isArray(this.payload.sellingUnits)) return;
        const idx = this.payload.sellingUnits.findIndex(u => u.unitCode === base);
        if (idx !== -1 && (!this.payload.sellingUnits[idx].salePrice || Number(this.payload.sellingUnits[idx].salePrice) <= 0)) {
          this.payload.sellingUnits[idx].salePrice = Number(v) || 0;
        }
      }
    },

    created() {
      this.loadFamilies();
      this.loadCategories();
      this.loadUnits();
    },
    methods: {
      displayUnit(code) {
        const c = typeof code === 'object' ? code.code : code;
        const u = this.allUnits.find(x => x.code === c);
        return u ? `${u.code} - ${u.label || u.description || ''}` : c;
      },
      openCreate() {
        this.editIndex = null;
        this.modalKey++;
        this.showModal = true;
      },
      closeModal() {
        this.showModal = false;
        this.editIndex = null;
      },
      openEdit(index) {
        if (!Array.isArray(this.payload.sellingUnits) || index < 0 || index >= this.payload.sellingUnits.length) return;
        this.editIndex = index;
        this.modalKey++;
        this.showModal = true;
      },
      setDefault(index) {
        if (!Array.isArray(this.payload.sellingUnits)) return;
        this.payload.sellingUnits = this.payload.sellingUnits.map((u, i) => ({ ...u, defaultUnit: i === index }));
      },
      remove(index) {
        if (!Array.isArray(this.payload.sellingUnits)) this.$set(this.payload, 'sellingUnits', []);
        if (index < 0 || index >= this.payload.sellingUnits.length) return;
        this.payload.sellingUnits.splice(index, 1);
      },
      ajouterUnit(newUnit) {
        const base = this.baseUnitCodeValue;

// Interdire d’ajouter l’unité de base avec contentQty ≠ 1
        if (newUnit.unitCode === base && String(newUnit.contentQty) !== '1') {
          this.$toast?.warning?.(`L’unité ${base} doit avoir un contenu = 1.`);
          return;
        }

// Interdire le doublon de unitCode (business rule backend)
        const exists = (this.payload.sellingUnits || []).some(u => u.unitCode === newUnit.unitCode);
        if (exists) {
          this.$toast?.warning?.(`L’unité ${newUnit.unitCode} existe déjà.`);
          return;
        }

        (this.payload.sellingUnits ||= []).push(newUnit);
        this.closeModal();
      },
      majUnit(updated) {
        const base = this.baseUnitCodeValue;
        const index = this.editIndex;

// Empêcher une ligne baseUnit d’avoir un contentQty ≠ 1
        if (updated.unitCode === base && String(updated.contentQty) !== '1') {
          this.$toast?.warning?.(`L’unité ${base} doit avoir un contenu = 1.`);
          updated.contentQty = 1;
        }

// Empêcher d’éditer vers un unitCode déjà utilisé ailleurs
        const duplicate = (this.payload.sellingUnits || []).some((u, i) =>
            i !== index && u.unitCode === updated.unitCode
        );
        if (duplicate) {
          this.$toast?.warning?.(`L’unité ${updated.unitCode} est déjà utilisée.`);
          return;
        }

        // default unique (inchangé)
        if (updated.defaultUnit) {
          (this.payload.sellingUnits || []).forEach((u, i) => { if (i !== index) u.defaultUnit = false; });
        } else {
          const othersHaveDefault = (this.payload.sellingUnits || []).some((u, i) => i !== index && u.defaultUnit);
          if (!othersHaveDefault) updated.defaultUnit = true;
        }

        this.$set(this.payload.sellingUnits, index, updated);
        this.closeModal();
      },
      toggleCustomFields() {
        this.showCustomFields = !this.showCustomFields;
      },
      isPayloadModified() {
        const compareKeys = Object.keys(this.payload);
        return compareKeys.some((key) => {
          return JSON.stringify(this.payload[key]) !== JSON.stringify(this.product[key]);
        });
      },
      resetForm() {
        // Réinitialise le payload
        this.payload = {
          name: '',
          description: '',
          referencePrice: 0,
          images: [
          ],
          managementType: '',
          commissionRate: 0,
          categoryCode: '',
          categoryDescription: '',
          familyCode: '',
          familyDescription: '',
          unitDescription: '',
          baseUnitCode: '',
          sellingUnits: [],
        }

        // Réinitialise la validation
        if (!this.product && this.$refs.observer) this.$refs.observer.reset();
        // Réinitialise les fichiers FilePond
        if (this.$refs.uploader) this.$refs.uploader.reset();
      },
      onImageRemoved(urlToRemove) {
        this.payload.images = this.payload.images.filter(img => img.url !== urlToRemove)
      },
      handleUploadedUrls(responses) {
        console.log("responssss", responses);
        // Tu reçois bien une liste d’objets { id, url }
        this.payload.images.push(...responses.map(r => ({
          id: null,
          imageId: r.id, // l'identifiant cloudinary
          url: r.url
        })));
        console.log(this.payload.images);
      },
      handleUploadedFiles(files) {
        console.log('Images sélectionnées :', files);
      },
      resetUpload() {
        this.$refs.multiUploader.reset();
      },
      handleFileUpload(files) {
        console.log('Fichiers reçus :', files);
        // traitement des fichiers ici
      },
      loadFamilies() {
        this.$http.get("/registry/families").then(({ data }) => this.allFamilies = data);
      },
      loadCategories() {
        this.$http.get("/registry/categories").then(({ data }) => this.allCategories = data);
      },
      loadUnits() {
        this.$http.get("/registry/units").then(({ data }) => this.allUnits = data);
      },
      ensureBaseUnitRow() {
        const base = this.baseUnitCodeValue;
        if (!base) return;

        if (!Array.isArray(this.payload.sellingUnits)) this.$set(this.payload, 'sellingUnits', []);

        const refPrice = Number(this.payload.referencePrice) || 0;
        const idx = this.payload.sellingUnits.findIndex(u => u.unitCode === base);

        if (idx === -1) {
          // Insère la ligne obligatoire pour l’unité de base
          this.payload.sellingUnits.push({
            unitCode: base,
            contentQty: 1,
            salePrice: refPrice,       // tu peux mettre 0 si tu ne veux pas forcer le prix
            defaultUnit: this.payload.sellingUnits.length === 0 // si c'est la 1ère, on la met par défaut
          });
        } else {
          // Corrige au cas où
          const row = this.payload.sellingUnits[idx];
          if (String(row.contentQty) !== '1') row.contentQty = 1;
          // Optionnel : si prix vide/0, caler sur referencePrice
          if (!row.salePrice || Number(row.salePrice) <= 0) row.salePrice = refPrice;
        }

        // Garantir qu'il y a exactement 1 "defaultUnit"
        const defaults = this.payload.sellingUnits.filter(u => u.defaultUnit).length;
        if (defaults === 0) {
          this.payload.sellingUnits[0].defaultUnit = true;
        } else if (defaults > 1) {
          let kept = false;
          this.payload.sellingUnits = this.payload.sellingUnits.map(u => {
            if (u.defaultUnit && !kept) { kept = true; return u; }
            return { ...u, defaultUnit: false };
          });
        }
      },
      buildSubmitBody() {
        // 1) extraire/normaliser les scalaires
        const baseUnitCode = this.payload.baseUnitCode?.code || this.payload.baseUnitCode || '';
        const categoryCode = this.payload.categoryCode?.code || this.payload.categoryCode || '';
        const familyCode = this.payload.familyCode?.code || this.payload.familyCode || '';

        // 2) normaliser sellingUnits (copie défensive)
        let sellingUnits = (this.payload.sellingUnits || []).map(u => ({
          unitCode: u.unitCode?.code || u.unitCode,
          contentQty: Number(u.contentQty),
          salePrice: Number(u.salePrice),
          defaultUnit: !!u.defaultUnit
        }));

        // 3) s’assurer de la présence de la ligne baseUnit ×1
        const refPrice = Number(this.payload.referencePrice) || 0;
        const idx = sellingUnits.findIndex(u => u.unitCode === baseUnitCode);
        if (idx === -1) {
          sellingUnits.push({
            unitCode: baseUnitCode,
            contentQty: 1,
            salePrice: refPrice,
            defaultUnit: sellingUnits.length === 0
          });
        } else {
          if (String(sellingUnits[idx].contentQty) !== '1') sellingUnits[idx].contentQty = 1;
          if (sellingUnits[idx].salePrice == null || Number(sellingUnits[idx].salePrice) < 0) {
            sellingUnits[idx].salePrice = refPrice;
          }
        }

        // 4) unicité unitCode
        const codes = sellingUnits.map(u => u.unitCode);
        const uniq = new Set(codes);
        if (uniq.size !== codes.length) {
          throw new Error('Chaque unité de vente doit avoir un code unique.');
        }

        // 5) exactement 1 defaultUnit
        const defaults = sellingUnits.filter(u => u.defaultUnit).length;
        if (defaults !== 1) {
          if (defaults === 0 && sellingUnits.length) {
            sellingUnits[0].defaultUnit = true;
          } else {
            let kept = false;
            sellingUnits = sellingUnits.map(u => {
              if (u.defaultUnit && !kept) {
                kept = true;
                return u;
              }
              return {...u, defaultUnit: false};
            });
          }
        }

        // 6) normaliser images avec fallback
        let images = this.payload.images && this.payload.images.length
            ? this.payload.images
            : [
            ];

        // 7) retourner un body IMMUTABLE à envoyer
        return {
          name: this.payload.name,
          description: this.payload.description,
          referencePrice: Number(this.payload.referencePrice),
          initialStock: Number(this.payload.initialStock || 0),
          images,                         // <<< images normalisées avec fallback
          managementType: this.payload.managementType,
          commissionRate: Number(this.payload.commissionRate),
          familyCode,
          categoryCode,
          subcategoryCode: this.payload.subcategoryCode || '',
          baseUnitCode,
          sellingUnits,
          quantityAlert: Number(this.payload.quantityAlert || 0),
          garantie: this.customFields.garantie ? this.payload.garantie : null,
          fabricant: this.customFields.fabricant ? this.payload.fabricant : null,
          expiryDate: this.customFields.expiryDate ? this.payload.expiryDate : null
        }
      },

      async submitForm() {
        if (this.product && !this.isPayloadModified()) {
          swal('Aucune modification', 'Vous devez modifier au moins un champ avant de sauvegarder.', 'info');
          return;
        }
        const isValid = await this.$refs.observer.validate();
        if (!isValid) return;

        const confirmed = await confirmAction(this.product ? 'update' : 'create');
        if (!confirmed) return;

        // Ne mute plus this.payload ici.
        let body;
        try {
          body = this.buildSubmitBody();  // <<< construit un body cohérent
        } catch (e) {
          this.$toast?.error?.(e.message || 'Validation front échouée.');
          return;
        }

        this.$loading(true);
        const request = this.product
            ? this.$http.put(`/products/${this.product.code}`, body)
            : this.$http.post("/products", body);

        request
            .then(() => {
              if (this.$refs.observer) this.$refs.observer.reset();
              setTimeout(() => {
                swal('Succès', `Produit ${this.product ? 'modifié' : 'créé'} avec succès.`, 'success');
                this.resetForm();
              }, 300);
              this.$emit('refresh');
              $('#modal-create-product').modal('hide');
            })
            .catch((err) => {
              console.error(err);
              setTimeout(() => showValidationErrors(err), 300);
            })
            .finally(() => this.$loading(false));
      },

      updateFamilyDetails(family) {
        // this.payload.familyCode = family?.code || '';
        this.payload.familyDescription = family?.label || '';
      },
      updateCategoryDetails(category) {
        // this.payload.categoryCode = category?.code || '';
        this.payload.categoryDescription = category?.label || '';
      },
      updateUnitDetails(unit) {
        // this.payload.unitCode = unit?.code || '';
        this.payload.unitDescription = unit?.label || '';
      },
    },
  };
</script>
